import moment from 'moment-timezone';

/** 一覧と詳細で同じ日時表記（JST）を使う。 */
export const formatSendHistoryDate = (value: string): string =>
  moment(value).tz('Asia/Tokyo').format('YYYY年M月D日 HH:mm');
